import {
  AddCustomItemWithSectionIdRequest,
  DeleteSectionCustomItemRequest,
  DeleteSectionRequest,
  UpdateSectionCustomItemRequest,
  UpsertSectionRequest
} from "src/model/api/custom-item-request.model";
import { TAG_GET_QUOTE } from "src/api/api-tags";
import { appApiSlice } from "src/api/app-ApiSlice";

export const sectionApiSlice = appApiSlice.injectEndpoints({
  endpoints: builder => ({
    addCustomSectionItem: builder.mutation<any, AddCustomItemWithSectionIdRequest>({
      query(customItemData: AddCustomItemWithSectionIdRequest) {
        return {
          url: `v1/section/custom-section-item`,
          method: 'POST',
          body: customItemData,
        }
      },
      invalidatesTags: [{ type: TAG_GET_QUOTE }],
    }),
    updateCustomSectionItem: builder.mutation<any, UpdateSectionCustomItemRequest>({
      query(customItemData: UpdateSectionCustomItemRequest) {
        return {
          url: `v1/section/custom-section-item`,
          method: 'PUT',
          body: customItemData,
        }
      },
      invalidatesTags: [{ type: TAG_GET_QUOTE }],
    }),
    deleteCustomSectionItem: builder.mutation<any, DeleteSectionCustomItemRequest>({
      query(customItemData: DeleteSectionCustomItemRequest) {
        return {
          url: `v1/section/custom-section-item`,
          method: 'DELETE',
          body: customItemData,
        }
      },
      invalidatesTags: [{ type: TAG_GET_QUOTE }],
    }),
    deleteSection: builder.mutation<any, DeleteSectionRequest>({
      query(sectionData: DeleteSectionRequest) {
        return {
          url: `v1/section`,
          method: 'DELETE',
          body: sectionData,
        }
      },
      invalidatesTags: [{ type: TAG_GET_QUOTE }],
    }),
    confirmSection: builder.mutation<any, UpsertSectionRequest>({
      query(sectionData: UpsertSectionRequest) {
        return {
          url: `v1/section`,
          method: 'POST',
          body: sectionData,
        }
      },
      invalidatesTags: [{ type: TAG_GET_QUOTE }],
    }),
    editSection: builder.mutation<any, UpsertSectionRequest>({
      query(sectionData: UpsertSectionRequest) {
        return {
          url: `v1/section`,
          method: 'PUT',
          body: sectionData,
        }
      },
      invalidatesTags: [{ type: TAG_GET_QUOTE }],
    })
  })

})

export const {
  useAddCustomSectionItemMutation,
  useUpdateCustomSectionItemMutation,
  useDeleteCustomSectionItemMutation,
  useDeleteSectionMutation,
  useConfirmSectionMutation,
  useEditSectionMutation
} = sectionApiSlice;